export const wideEventsStatuses = [
  { text: 'Pendiente', value: 'P', color: 'orange darken-2', icon: 'mdi-file-send' },
  { text: 'Recibida', value: 'RECIBIDA', color: 'blue darken-2', icon: 'mdi-file-document-check' },
  { text: 'Devuelta', value: 'DEVUELTA', color: 'red darken-4', icon: 'mdi-file-undo' },
  { text: 'Autorizado', value: 'AUTORIZADO', color: 'green darken-2', icon: 'mdi-file-check' },
  { text: 'No Autorizado', value: 'NO_AUTORIZADO', color: 'red darken-2', icon: 'mdi-file-document-remove' },
  { text: 'Notificado', value: 'NOTIFICADO', color: 'green darken-2', icon: 'mdi-email-check' },
  { text: 'No Notificado', value: 'NO_NOTIFICADO', color: 'red darken-2', icon: 'mdi-email-remove' },
  { text: 'Error Email', value: 'ERROR_EMAIL', color: 'red', icon: 'mdi-email-alert' },
  { text: 'Error Construcción', value: 'ERROR_CONSTRUCCION', color: 'red', icon: 'mdi-xml' },
  { text: 'Error Firma', value: 'ERROR_FIRMA', color: 'red', icon: 'mdi-file-certificate' },
  { text: 'Error Token', value: 'ERROR_TOKEN', color: 'red', icon: 'mdi-key-alert' },
  { text: 'Error', value: 'ERROR', color: 'red darken-4', icon: 'mdi-alert-circle' },
]

export const wideEventsProcesses = [
  { text: 'Recepción', value: 'recepcion' },
  { text: 'Autorización', value: 'autorizacion' },
  { text: 'Notificación', value: 'notificacion' },
  { text: 'Sincronización', value: 'sincronizacion' },
  { text: 'Reprocesamiento', value: 'reprocesamiento' },
  { text: 'Job Pendientes', value: 'job_pendientes' },
  { text: 'Job API Fiscal', value: 'job_api_fiscal' },
]

export const getStatusColor = (status) => {
  const found = wideEventsStatuses.find(s => s.value === status)
  return found ? found.color : 'grey'
}

export const getStatusIcon = (status) => {
  const found = wideEventsStatuses.find(s => s.value === status)
  return found ? found.icon : 'mdi-help-circle'
}

export const getProcessLabel = (process) => {
  const found = wideEventsProcesses.find(p => p.value === process)
  return found ? found.text : process
}

export const getStageLabel = (stage) => {
  const labels = {
    parsing: 'Parseo XML',
    generar_claves: 'Generación Claves',
    registro_db: 'Registro BD',
    firma_digital: 'Firma Digital',
    envio_sri: 'Envío SRI',
    autorizacion_sri: 'Autorización SRI',
    generacion_pdf: 'Generación PDF',
    envio_email: 'Envío Email',
    sincronizacion: 'Sincronización',
  }
  return labels[stage] || stage
}

export const getStageStatusIcon = (status) => {
  const icons = {
    success: { icon: 'mdi-check-circle', color: 'green' },
    error: { icon: 'mdi-close-circle', color: 'red' },
    skipped: { icon: 'mdi-minus-circle', color: 'grey' },
    interrupted: { icon: 'mdi-alert', color: 'orange' },
    incomplete: { icon: 'mdi-circle-half-full', color: 'orange' },
  }
  return icons[status] || { icon: 'mdi-help-circle', color: 'grey' }
}

export const formatDuration = (ms) => {
  if (ms == null) return '-'
  if (ms < 1000) return `${Math.round(ms)}ms`
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`
  const minutes = Math.floor(ms / 60000)
  const seconds = ((ms % 60000) / 1000).toFixed(0)
  return `${minutes}m ${seconds}s`
}
